/*eslint-disable */

import {
  mapGetters
} from 'vuex';

var $ = window.jQuery = require('jquery');

export default {
  name: 'blog',
  components: {},
  props: [],
  data () {
    return {
      blogListState:null,
      blogListResults:[],
      publicBlogListState:null,
      publicBlogListResults:[],
      is_guestuser:false,
      is_superuser:false,
      pubBlogState:true,
      selfUserId:'',
      profileUpdateAlertPopup:false
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters',
      'publicBlogListGetters',
      'blogListGetters'
    ]),
    getUserDetailsAgainFun(){
      this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    SetIntialUserStatus(){
      if (this.userDetails) {
        this.is_guestuser = this.userDetails.guest
        this.is_superuser = this.userDetails.is_superuser
      }
      return
    },
    getBlogListFun(){
      this.blogListState = this.$store.getters.blogListGetters.data
      return
    },
    setInitialBlogStates(){
      if(this.blogListState){
        this.blogListResults = this.blogListState.results
      }
    },
    getPubBlogListFun(){
      this.publicBlogListState = this.$store.getters.publicBlogListGetters.data
      return
    },
    setInitialPubBlogStates(){
      if(this.publicBlogListState){
        this.publicBlogListResults = this.publicBlogListState.results
      }
    },
  },
  mounted () {
    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    this.getUserDetailsAgainFun
    this.getBlogListFun
    this.setInitialBlogStates
    this.getPubBlogListFun
    this.setInitialPubBlogStates

  },
  methods: {
    userInfoAlertPopupOpenFun(){
      $('body').addClass('body_right_scroll_remove')
      this.profileUpdateAlertPopup =  true
    },
    userInfoAlertPopupClosedFun(){
      $('body').removeClass('body_right_scroll_remove')
      this.profileUpdateAlertPopup =  false
    },
    OnlyShowMyBLogsFun(){
      if(this.pubBlogState === true){
        this.pubBlogState = false
      }else{
        this.pubBlogState = true
      }
    },

  },
  watch:{
    getUserDetailsAgainFun(){
      return this.$store.getters.acUserDetailsStateGetters
    },
    SetIntialUserStatus(){
      if (this.userDetails) {
        this.is_guestuser = this.userDetails.guest
        this.is_superuser = this.userDetails.is_superuser
      }
    },
    getBlogListFun(){
      return this.$store.getters.blogListGetters
    },
    setInitialBlogStates(){
      if(this.blogListState){
        this.blogListResults = this.blogListState.results
      }
    },
    getPubBlogListFun(){
      return this.$store.getters.publicBlogListGetters
    },
    setInitialPubBlogStates(){
      if(this.publicBlogListState){
        this.publicBlogListResults = this.publicBlogListState.results
      }
    },
  }
}